/**
 * @copyright
 * Copyright (c) 2024 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */

export const ReportTypeMap = {
  totalStats: "TOTAL_STATS",
  platformStats: "PLATFORM_STATS",
  userValue: "USER_VALUE",
  geo: "GEO",
  upsellStats: "UPSELL_STATS",
  pastPayouts: "PAST_PAYOUTS",
  userSpending: "USER_SPENDING",
  videoSales: "VIDEO_SALES",
} as const;

export enum ReportTypeEnum {
  totalStats = "totalStats",
  platformStats = "platformStats",
  userValue = "userValue",
  geo = "geo",
  upsellStats = "upsellStats",
  pastPayouts = "pastPayouts",
  userSpending = "userSpending",
  videoSales = "videoSales",
}

export const DeviceTypeMapper = {
  undefined: "ALL",
  Desktop: "DESKTOP",
  Mobile: "MOBILE",
  Tablet: "TABLET",
  Console: "CONSOLE",
  "Smart TV": "SMART_TV",
} as const;

export enum DeviceTypeEnum {
  undefined = "undefined",
  Desktop = "Desktop",
  Mobile = "Mobile",
  Tablet = "Tablet",
  Console = "Console",
  "Smart TV" = "Smart TV",
}

export enum GroupByEnum {
  tm = "tm",
  trkid = "trkid",
  refid = "refid",
  ctry = "ctry",
  dev = "dev",
}

export const GroupByMapper = {
  tm: "DATE",
  trkid: "TRACKING_ID",
  refid: "REFERRER_ID",
  ctry: "COUNTRY",
  dev: "PLATFORM",
} as const;

export enum ButtonNameEnum {
  SUCCESS = "checkCircle",
  DELETE = "close",
  FAILED = "error",
  DOWNLOAD = "fileDownload",
  MARKED_FOR_DELETION = "cancel",
}

export enum ReportStatusEnum {
  IDLE = "idle",
  SUCCESS = "success",
  PENDING = "pending",
  FAILED = "failed",
  MARKED_FOR_DELETION = "markedForDeletion",
}

export const ReportStatusTooltip: Record<ReportStatusEnum, string> = {
  [ReportStatusEnum.SUCCESS]: "tool_tip_main.done",
  [ReportStatusEnum.FAILED]: "tool_tip_main.fail",
  [ReportStatusEnum.PENDING]: "tool_tip_main.loading",
  [ReportStatusEnum.MARKED_FOR_DELETION]: "",
  [ReportStatusEnum.IDLE]: "",
};
